import React from 'react'
import { NavLink } from 'react-router-dom';

// Components.
import { Nav, NavItem } from 'reactstrap';

const navItems = [{
    text: 'Home',
    url: '/',
}, {
    text: 'Beta Roles',
    url: '/beta-roles'
},{
    text: 'FAQ',
    url: '/faq'
}];

function MainNav() {
  return (
    <Nav aria-label="Primary" className="justify-content-center gap-2 gap-md-3 align-self-end">
        {navItems.map(({ text, url }) => (
            <NavItem key={`nav-item-${text}`}>
                <NavLink
                    end={url === '/'}
                    to={url}
                    className={({ isActive }) => `main-nav-link fs-6 text-capitalize text-secondary ${isActive ? 'active' : ''}`}
                >
                    {text}
                </NavLink>
            </NavItem>
        ))}
    </Nav>
  )
}

export default MainNav
